import { CAMERA_DURATION_MAX, CAMERA_DURATION_MIN } from '../devices/camera_local_actions';
//Types
import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

export const invalidLightsAction = (method: string, controlOption: LocalControlOptions): boolean => {
	return (
		/^(rgbw?|light|cct|rgbcct).set$/.test(method) &&
		!controlOption.onOffState?.checked &&
		!controlOption.attr?.brightness &&
		!controlOption.attr?.rgb &&
		!controlOption.attr?.ct &&
		!controlOption.attr?.offset &&
		!controlOption.attr?.offset_white &&
		!controlOption.attr?.white
	);
};

export const invalidCoverAction = (
	isCalibrated: boolean,
	controlOption: LocalControlOptions,
): boolean => {
	return (
		(controlOption?.attr?.pos != undefined && !isCalibrated) ||
		(controlOption?.attr?.pos != undefined &&
			!controlOption?.attr?.pos &&
			!controlOption?.attr?.slat_pos &&
			!controlOption?.attr?.slat_rel &&
			isCalibrated)
	);
};

export const invalidTransitionDurationAction = (
	transitionDuration: {
		min: number;
		max: number;
		showError: boolean;
		disabled: boolean;
	},
	controlOption: LocalControlOptions,
): boolean => {
	return (
		controlOption?.attr?.transition_duration &&
		(controlOption?.params?.transition_duration < transitionDuration.min ||
			controlOption?.params?.transition_duration > transitionDuration.max)
	);
};

export const invalidToggleAfterAction = (controlOption: LocalControlOptions): boolean => {
	return (
		controlOption?.attr?.toggle_after &&
		!(
			Number.isSafeInteger(controlOption?.params?.toggle_after) &&
			controlOption?.params?.toggle_after >= 0
		)
	);
};

export const invalidCuryAction = (method: string, controlOption: LocalControlOptions): boolean => {
	return (
		(/^(cury.set)$/.test(method) &&
			!controlOption.onOffState?.checked &&
			!controlOption.attr.intensity) ||
		(/^(cury.setconfig)$/.test(method) &&
			Object.values(controlOption?.attr?.config?.ambient || {}).every((i) => !i))
	);
};

export const invalidTRVAction = (method: string, errorInput: boolean): boolean => {
	return /^((blu)?trv.boost)$/.test(method) && errorInput;
};

export const invalidLNMAction = (controlOption: LocalControlOptions, errorInput: boolean): boolean => {
	return Boolean(controlOption?.lnm) && errorInput;
};

export const invalidCameraAction = (method: string, controlOption: LocalControlOptions): boolean => {
	const duration = Number(controlOption?.params?.duration);
	return (
		(method === 'camera.startrecording' &&
			controlOption?.attr?.duration &&
			(!Number.isSafeInteger(duration) ||
				duration < CAMERA_DURATION_MIN ||
				duration > CAMERA_DURATION_MAX)) ||
		(method === 'camera.setconfig' &&
			Object.values(controlOption?.attr?.config || {}).every((i) => !i)) ||
		(method === 'camerazone.setconfig' &&
			(controlOption?.params?.id == null ||
				Object.values(controlOption?.attr?.config || {}).every((i) => !i)))
	);
};
